var map = {
	"./bgd.jpg": 6521,
	"./kls.jpg": 1747,
	"./krE.jpg": 5497,
	"./krT.jpg": 4369,
	"./kuz.jpg": 4501,
	"./mainPage/1.jpg": 5210,
	"./mainPage/2.jpg": 8545,
	"./mainPage/3.jpg": 1487,
	"./mainPage/4.jpg": 1730,
	"./mainPage/5.jpg": 4319,
	"./mainPage/6.jpg": 6950,
	"./mak.jpg": 3583,
	"./pla.jpg": 7149,
	"./pro.jpg": 5068,
	"./rya.jpeg": 9127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;